module.exports = __webpack_public_path__ + "static/komacchi_u-960b7fa6d1348039b7e5d1ad8a214e50.jpg";